const datas = [
    {
        "id": "1",
        "year": "2012 - 2015",
        "job": "Bechelor Degree",
        "company": "King Mongkut's University of Technology Thonburi (KMUTT)",
        "description": "Bachelor of Engineering in Computer Engineering (International Program), ",
        "description_two": "King Mongkut’s University of Technology Thonburi (KMUTT) – Thailand GPA 3.77 on a scale of 4.00 - First Class Honor (Completed – 8 semesters)"
    },
    {
        "id": "2",
        "year": "2015",
        "job": "Research Assistant",
        "company": "Institute of High Performance Computing (iHPC), Agency for Science, Technology and Research (A*STAR), Singapore",
        "description": "I worked as a research assistant for my summer internship on a machine learning project about convolutional neural network for image recognition.",
        "description_two": ""
    },
    {
        "id": "3",
        "year": "2016",
        "job": "Admin/Coordinator",
        "company": "Hatch (Startup Incubator), King Mongkut’s University of Technology Thonburi, Thailand",
        "description": "I worked for the university newly founded startup incubation program in my senior year. My responsibility includes accounting and coordinating and recruiting staff for events.",
        "description_two": ""
    },
    {
        "id": "4",
        "year": "2016 - 2017",
        "job": "Java Developer:",
        "company": "Charoentut company(CT) as a vendor for Advanced Info Service (AIS), Thailand",
        "description": "I worked for a vendor company which develop back-end java program for AIS telecommunication system. My responsibility includes developing java programs, maintain existing programs, and changing the programs according to customer’s requirements.",
        "description_two": ""
    },
    {
        "id": "5",
        "year": "2016 - 2017",
        "job": "Research Assistant",
        "company": "Big Data Experience Center (BX), Thailand",
        "description": "I worked as a research assistant because I received a full scholarship for my master degree from BX. My work includes gathering client’s requirement, analyzing/visualizing their data, gathering more data, preprocessing data, creating models, and ultimately solving the problem using data analytics. I work as both a data scientist and data engineer.",
        "description_two": ""
    },
    {
        "id": "6",
        "year": "2018 - 2020",
        "job": "Data Scientist:",
        "company": "Electronics Extreme (Extreme Studio), Thailand",
        "description": "As a data scientist my responsibilities includes writing scripts to process data, assisting in database design for game analytics for currently developing games, visualizing current games’ revenue for the games that the company publishes, planning for future in-game selling strategies and crawling information about games in the market from the Internet.",
        "description_two": ""
    }
]

export default datas;
